import { render, staticRenderFns } from "./DetailsPlanning.vue?vue&type=template&id=ae88eb88&"
import script from "./DetailsPlanning.vue?vue&type=script&lang=ts&"
export * from "./DetailsPlanning.vue?vue&type=script&lang=ts&"
import style0 from "./DetailsPlanning.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports